export const SOFTLINE_API_PRODUCT = '/product-service/products/{{id}}';
export const SOFTLINE_API_PRODUCT_UNIT_CONVERSIONS =
  '/product-service/products/{{id}}/unit-conversions';
export const SOFTLINE_API_PRODUCT_SUPPLIER_INFORMATION =
  '/product-service/products/{{id}}/supplier-information';
export const SOFTLINE_API_PRODUCT_SUPPLIER_INFORMATION_MAIN =
  '/product-service/products/{{id}}/supplier-information/main';
export const SOFTLINE_API_PRODUCT_STORAGE_LOCATIONS =
  '/product-service/products/{{id}}/storage-locations';
export const SOFTLINE_API_PRODUCT_SALES_PRICES =
  '/product-service/products/{{id}}/sales-prices';
export const SOFTLINE_API_PRODUCT_SALES_ORGANISATION_STATUSES =
  '/product-service/products/{{id}}/sales-organisation-statuses';
export const SOFTLINE_API_PRODUCT_PURCHASING_PRICES =
  '/product-service/products/{{id}}/purchasing-prices';
export const SOFTLINE_API_PRODUCT_PROMOTIONS =
  '/product-service/products/{{id}}/promotions';
export const SOFTLINE_API_PRODUCT_IMAGES = '/product-service/products/{{id}}/images';
export const SOFTLINE_API_PRODUCT_IMAGES_MAIN =
  '/product-service/products/{{id}}/images/main';
// TODO: WIP — replace the legacy /v1/items/stock/amount endpoint (artstamm ids,
// { result } envelope; also used by wws/artikel-info and wws/core) with a
// product-service stock endpoint once the backend exposes one.
export const SOFTLINE_API_ITEM_STOCK_AMOUNT = '/v1/items/stock/amount';

/** stock-level-service: Lagerstände je Lager zu einem Artikel (POST, artstamm
    id in the path). Replaces what SOFTLINE_API_ITEM_STOCK_AMOUNT does today —
    see the TODO there. */
export const SOFTLINE_API_STOCK_LEVEL = '/stock-level-service/stock-level/{{id}}';
